import { RootState } from "..";

export const selectAccessToken = (state: RootState): string | null => state.auth?.accessToken;
